import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img1 from '../assets/others/11102054.jpg'
import checkicon from '../assets/icons/check-circle-wt.svg'
import img3 from '../assets/others/11102055.jpg'
import img8 from '../assets/course/image-1.png'
import img2 from '../assets/course/image-2.png'
import img7 from '../assets/course/image-3.png'
import img4 from '../assets/course/image-4.png'
import img5 from '../assets/course/image-5.png'
import img6 from '../assets/course/image-6.png'
import Clientsay from '../Components/Clientsay/Clientsay'
import { Counterbox } from '../Components/Counterbox/Counterbox'
import Iconbox from '../Components/Iconbox/Iconbox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
library.add(fas)

const Corporate = () => {
  return (
    <div>
        <Helmet>
        <title>Corporate VLSI Training in Bangalore | Best Corporate VLSI Training Courses in Bangalore - Takshila VLSI</title>
        <meta name="description" content="Get Corporate VLSI Training in Bangalore with Takshila VLSI. We offer excellent corporate VLSI training in Bangalore by highly experienced mentors." />
        <link rel="canonical" href="https://www.takshila-vlsi.com/corporate-trainings/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Corporate VLSI Training in Bangalore | Best Corporate VLSI Training Courses in Bangalore - Takshila VLSI" />
        <meta property="og:description" content="Get Corporate VLSI Training in Bangalore with Takshila VLSI. We offer excellent corporate VLSI training in Bangalore by highly experienced mentors." />
        <meta property="og:url" content="https://www.takshila-vlsi.com/corporate-trainings/" />
        <meta property="og:site_name" content="Takshila VLSI" />
        <meta property="article:modified_time" content="2022-03-01T13:03:13+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <Header/>
        <main>
        <section className='section-banner pg-banner p-lg-5 p-3 pt-4'>
            <div class="container">
                          <div class="row">
                              <div class="col-lg-6 align-self-center">
                                <div class="pg-title-sec pe-5 pb-4">
                                    <h1 className='pg-title pb-3'>Best Corporate <span class="bg-txt">VLSI Training</span> Center in Bangalore</h1>
                                    <p className='pg-title-desc'>We’re on a mission to deliver engaging, curated courses at a reasonable price.

</p>
                                </div>
                                <div class="col-md-12 align-self-center mb-3">
                                    <a href='/contact-us'>
                                         <button class="btn-primary btn-icon ms-0">Apply Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                                              </a>
                                                               </div>
                              </div>
                              <div class="col-md-6 img-radius">
                            <img src={img1} alt=''/>
                          </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-md-6 img-radius">
                            
                          </div>
                          </div>
            </div>
            </section>
            <section className='p-lg-5 pb-4'>
            <div class="container ">
                <div class="row">
                
                    <div class="col-lg-12">
                    <div className='bg-drk-3 p-lg-5 p-3 radius-1 dark-bg'>
                        <div class="col-lg-12">
                        <h2 class="ws-section_heading txt-3 text-center">Corporate VLSI Training</h2>
                        <p> Our corporate VLSI training program, is a targeted VLSI training for companies that require their employees to learn VLSI. We run the best corporate VLSI training centers in all of our locations. We provide corporate establishments as well as organizations with a wide multitude of varying training options – it matters not whether it is for a team or a single employee, we feature classes that range from contemporary regular classes right up to customized classes for your employees. The highpoint of our corporate training program is;
                         </p>
                        </div>
                
                    <div class="col-lg-12 pt-3">
                        <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">A wide range of courses that cover all aspects of VLSI services.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">The most trending tools you can find in the entire industry which enable us to meet and even surpass current industry standards.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">The most experienced trainers that the industry has to offer.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">The most flexible payment plans and options that can be gotten in the entire industry.</div>
                            </div>
                            
                    </div>  
                    </div>  
                    </div> 
                </div>
                </div>
            </section>

            <div class="coursebox-section ws-section dark-background-2 pb-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <h2 class="ws-section_heading pd-03">Customized Training Programs</h2>
                </div>
                <div class="col-lg-4 align-self-center">
                    <a href='/courses'>
                    <button class="btn-primary btn-icon" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                </a>
                </div>
            </div>

            <div class="row align-items-center gx-xl-28 mt-5">
                <div class="col-lg-6 mb-5">
                    <div class="course-box">
                        <div class="course-box-top">
                            <img src={img8} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/physical-design'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Physical Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Physical Design Training course mainly focused on giving complete hands on experience to physical design and physical verification training flow with latest tools and full lab practice.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img2} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/design-for-test/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Design For Test (DFT)</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Design For Testability (DFT) is a specialization in the SOC design cycle, to detect the manufacturing defects in a design. With the increase in size & complexity of chips.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img7} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/asic-verification/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">ASIC Verification</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Mainly focused on enhancing the Design Verification skills needed by industry. The curriculum is designed to include the latest methodologies being adopted by industry.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img4} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='/product/analog-layout-design/'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Analog Layout Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Analog Layout Design / Custom Layout Design / IC design training course mainly focused on giving hands-on practical exposure in doing chip layout design for a given analog & mixed signal design.</p>
                        </div>
                    </div>
                </div>
                

                
            </div>

        </div>
    </div>
        <section className='p-lg-5'>
        <Counterbox/>
        </section>
        
        <section className='ws-section clientsay-section bg-5 dark-bg pb-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>What Our Clinet Says</h2>
                        </div>
                    </div>
                    <Clientsay/> 
             </div>
          </section>
          <section className='pb-5'>
            <Iconbox/>
            </section>
            <section className='connect-section ws-section pb-5'>
                <div class="row mb-5">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>Connect With Us</h2>
                        </div>
                    </div>
          <div className='container'>
          <div class="row">
                <div class="col-lg img-radius">
                <img src={img3} alt=''/>
                </div>
                <div class="col-lg ml--10 mt-5">
                  <div className='ctn-frm'>
                  <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                </div>
                </div>
                
            </div>
            </div>
          </section>
        </main>
        <Enrollaction/>
        <Partnersec/> 
        <Footer/>
    </div>
  )
}

export default Corporate